import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "tableSearch",
    pure: true
})
export class TableSearchPipe implements PipeTransform {
    transform(value: any, searchText: string) {
        if(!value) return null;
        if(!searchText) return value;

        return value.filter((data: any) => {
            return JSON.stringify(data).toLowerCase().match(searchText.toLowerCase());
        })
    }
}